import { clientUrls } from "misc/urls/clientUrls";

const standardSidebarItems = [
    {
        title: "t_dashboard",
        key: "dashboard",
        icon: ["fas", "cars"],
        url: clientUrls.zspl.dashboard(),
        allowed: ["permission_zspl"]
    },
    {
        title: "t_vlv",
        key: "modules-vlv",
        icon: ["fas", "signal-stream"],
        url: clientUrls.modules.vlv.baseUrl(),
        allowed: ["permission_module_vlv"],
        items: [
            {
                title: "t_vlv_status",
                key: "vlv-status",
                url: clientUrls.modules.vlv.status()
            }
        ]
    },
    {
        title: "t_cdda",
        key: "modules-cdda",
        icon: ["fas", "magnifying-glass-chart"],
        url: clientUrls.modules.cdda.baseUrl(),
        allowed: ["permission_module_cdda"],
        items: [
            {
                title: "t_cdda_overview",
                key: "cdda-overview",
                url: clientUrls.modules.cdda.overview()
            },
            {
                title: "t_cdda_drivers_log",
                key: "cdda-drivers-log",
                url: clientUrls.modules.cdda.driversLog()
            },
            {
                title: "t_cdda_defect_tickets",
                key: "cdda-defect-tickets",
                url: clientUrls.modules.cdda.defectTickets()
            }
        ]
    },
    {
        title: "t_energy_monitor",
        key: "modules-energy-monitor",
        icon: ["fas", "bolt"],
        url: clientUrls.modules.energyMonitor.baseUrl(),
        allowed: ["permission_module_energy-monitor"]
    },
    {
        title: "t_cm",
        key: "modules-cm",
        icon: ["fas", "charging-station"],
        url: clientUrls.modules.cm.baseUrl(),
        allowed: ["permission_module_cm"],
        items: [
            {
                title: "t_cm_dashboard",
                key: "cm-dashboard",
                url: clientUrls.modules.cm.dashboard()
            },
            {
                title: "t_cm_fleet",
                key: "cm-fleet-view",
                url: clientUrls.modules.cm.fleetView()
            },
            {
                title: "t_cm_wiki",
                key: "wiki",
                url: clientUrls.modules.cm.wiki()
            },
            {
                title: "t_cm_parameters",
                key: "parameters",
                url: clientUrls.modules.cm.parameters(),
                allowed: ["permission_module_cm-extended"]
            }
        ]
    },
    {
        title: "t_bm",
        key: "modules-bm",
        icon: ["fas", "battery-full"],
        allowed: ["permission_module_bm"],
        items: [
            {
                title: "t_bm_overview",
                key: "bm-overview",
                url: clientUrls.modules.bm.overview()
            },
            {
                title: "t_bm_batteries",
                key: "bm-batteries",
                url: clientUrls.modules.bm.batteries()
            }
        ]
    },
    {
        title: "t_engineering",
        key: "modules-engineering",
        icon: ["fas", "user-helmet-safety"],
        url: clientUrls.modules.engineering.baseUrl(),
        allowed: ["permission_module_engineering"],
        items: [
            {
                title: "t_engineering_errors",
                key: "engineering-errors",
                url: clientUrls.modules.engineering.errors(),
                allowed: ["permission_module_engineering-extended"]
            },
            {
                title: "t_engineering_signals",
                key: "engineering-signals",
                url: clientUrls.modules.engineering.signals()
            },
            {
                title: "t_engineering_diagnostics",
                key: "engineering-diagnostics",
                url: clientUrls.modules.engineering.diagnostics(),
                allowed: ["permission_module_engineering-extended"]
            }
        ]
    }
];

const adminSidebarItems = [
    {
        title: "t_users",
        key: "user-management-users",
        url: clientUrls.userManagement.users.baseUrl(),
        allowed: ["permission_module_user-management"],
        icon: "users"
    },
    {
        title: "t_roles",
        key: "user-management-roles",
        url: clientUrls.userManagement.roles.baseUrl(),
        allowed: ["permission_module_user-management"],
        icon: "money-check-pen"
    }
];

export const getSidebarItems = () => {
    const location = window.location.pathname;

    if (location.includes("user-management")) return adminSidebarItems;

    return standardSidebarItems;
};
